import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getCookie, getRootCookieDomain, setCookie } from "./cookie";
import { slAddToCart } from "./analytics/sl";
var CART_URL = '/basket/';
var CART_ID_COOKIE_NAME = 'basket_id';
var CART_REDIRECT_COOKIE_NAME = 'basket_redirect';
var region = '';

/**
 * @desc: установка значения региона для использования в других утилитах
 * @returns {string}
 */
var getRegion = function getRegion(regionName) {
  region = regionName;
  return region;
};

/* конфиг для апикеев */
var API_KEY_PLACES = {
  tariffCard: '3304c11943c2363f47f4f8371a0403e6b5caa63b',
  mainPage: '4fe12ff5376a2e4aa865a2ea274b8ef2fc3db7e',
  mainPageFancy: '5e40c86333bb37e18fbdfed0f77a1c05bf092845',
  fancyNumberPage: '46fe14ebef1ff6a5d39bba014b868a9f950c3f35',
  Bronze: 'e1b6e7008eb3b1ba19651d858f2d495943e2d50d',
  mnp: 'd8fcc3645ab048c3e57015ffc70617df6fcd42d4',
  TariffZLand: '82c3d291b624448f8c62cac6a537273d3f4243a6',
  siteMain: '562feda6583fa4c9d76dbc8342a550601e19769e',
  searchPage: '0c41c184b7f82ea4d4c93bfdbee43ea32be33a5e',
  searchPopup: '83f7ef00d9d974c09604312475c99a1943162013'
};
var BOUGHT_NUMBERS_STORAGE_KEY = 'boughtNumbers';
var CART_COOKIE_TTL = 86400000;

/**
 * @desc: вернет id ркгиона
 * @returns {number}
 */
var getRegionId = function getRegionId() {
  var regionId = document.querySelector('meta[name="REGION_ID"]');
  if (regionId) {
    return +regionId.content;
  }
  return null;
};

/**
 * @desc: вернет id куки для апи корзины
 * @returns {null|string}
 */
var getCartId = function getCartId() {
  var cartId = getCookie(CART_ID_COOKIE_NAME);
  if (cartId) {
    return cartId;
  }
  return null;
};

/**
 * @desc: проверит наличие корзины (id куки) и если это новая корзина - вернет id ркгиона
 * @returns {number}
 */
var setRegionId = function setRegionId() {
  return !getCartId() && getRegionId();
};

/**
 * @desc: форматируем данные из корзины
 * @param items состав корзины
 * @returns {{devices: *[], numbers: *[]}}
 */
var getPurchasedItems = function getPurchasedItems(items) {
  var purchasedItems = {
    devices: [],
    numbers: []
  };
  var getItemData = function getItemData(item) {
    var _item$children;
    if (!item.isExcluded) {
      var _item$details;
      if (item.itemType === 'product' && item.id) {
        purchasedItems.devices = [].concat(_toConsumableArray(purchasedItems.devices), [parseInt(item.id, 10)]);
      } else if (item.itemType === 'ctn' && item !== null && item !== void 0 && (_item$details = item.details) !== null && _item$details !== void 0 && _item$details.ctn) {
        purchasedItems.numbers = [].concat(_toConsumableArray(purchasedItems.numbers), [item.details.ctn]);
      }
    }
    if (item !== null && item !== void 0 && (_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length) {
      item.children.forEach(function (childItem) {
        getItemData(childItem);
      });
    }
  };
  if (items !== null && items !== void 0 && items.length) {
    items.forEach(function (item) {
      getItemData(item);
    });
  }
  return purchasedItems;
};

/**
 * @desc: формирует тело и url запроса для добавления товара в корзину
 * @param {Object} config
 * @param {*=} config.tariffId - id тарифа
 * @param {*=} config.ctn - номер телефона
 * @param {*=} config.additionalSimOptions - доп опции при заказе тарифа (например, доп соки)
 * @param {*=} config.mnp - переход со своим номером
 * @param {*=} config.simOrderPlace - страница, на которой происходит заказ
 * @param {*=} config.basketSource - страница, на которой происходит заказ
 * аналог simOrderPlace, но приходит только от нескольких клонов mnp
 * @param {*=} config.devices - содержимое корзины
 * @param {*=} config.constructorTariffData
 * @param {*=} config.personalPlanData
 * @param {Object} config.additionalCtnOptions - доп опции при заказе номера (например, niceClass)
 * @param {string|null} [outerRegion] - регион пользователя, указанный снаружи для случая инициализации модуля без шапки сайта
 * @returns {{apiEndpoint: string, body: {regionPath: *, items: [{}]}}}
 */
var formatOrderData = function formatOrderData(_ref) {
  var _constructorTariffDat, _constructorTariffDat2;
  var tariffId = _ref.tariffId,
    ctn = _ref.ctn,
    additionalSimOptions = _ref.additionalSimOptions,
    mnp = _ref.mnp,
    simOrderPlace = _ref.simOrderPlace,
    basketSource = _ref.basketSource,
    devices = _ref.devices,
    constructorTariffData = _ref.constructorTariffData,
    personalPlanData = _ref.personalPlanData,
    additionalCtnOptions = _ref.additionalCtnOptions;
  var outerRegion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var body = {
    regionPath: outerRegion || region,
    regionId: setRegionId(),
    items: []
  };
  var itemsBody = {};
  var optionSocsArray = constructorTariffData === null || constructorTariffData === void 0 ? void 0 : (_constructorTariffDat = constructorTariffData.optionSocs) === null || _constructorTariffDat === void 0 ? void 0 : _constructorTariffDat.split(',');
  var partnersIdArray = constructorTariffData === null || constructorTariffData === void 0 ? void 0 : (_constructorTariffDat2 = constructorTariffData.partnersId) === null || _constructorTariffDat2 === void 0 ? void 0 : _constructorTariffDat2.split(',');
  var presets = (constructorTariffData === null || constructorTariffData === void 0 ? void 0 : constructorTariffData.tariffConstructorId) && optionSocsArray && {
    id: constructorTariffData === null || constructorTariffData === void 0 ? void 0 : constructorTariffData.tariffConstructorId,
    options: optionSocsArray,
    partnersId: partnersIdArray
  };
  var additionalServices = personalPlanData === null || personalPlanData === void 0 ? void 0 : personalPlanData.split(',');
  var cartId = getCartId();

  /* добавляется только тариф */
  if (tariffId) {
    itemsBody = {
      id: tariffId,
      itemType: 'tariff',
      details: {
        subscriberType: 'new',
        presets: presets,
        additionalServices: additionalServices
      },
      children: []
    };

    /* доп опции для тарифа */
    if (additionalSimOptions) {
      itemsBody = _objectSpread(_objectSpread({}, itemsBody), {}, {
        details: _objectSpread(_objectSpread({}, itemsBody.details), additionalSimOptions)
      });
    }
  }

  /* добавляется только номер */
  if (!tariffId && ctn) {
    itemsBody = {
      itemType: 'ctn',
      details: {
        ctn: ctn,
        subscriberType: 'new',
        presets: presets,
        additionalServices: additionalServices
      }
    };

    /* доп опции для номеров */
    if (additionalCtnOptions) {
      itemsBody = _objectSpread(_objectSpread({}, itemsBody), {}, {
        details: _objectSpread(_objectSpread({}, itemsBody.details), additionalCtnOptions)
      });
    }
  }

  /* mnp - переход со своим номером */
  if (mnp) {
    if (!tariffId) {
      itemsBody = {
        itemType: 'ctn',
        details: {
          subscriberType: 'mnp',
          ctn: mnp
        }
      };
    } else {
      itemsBody = {
        id: tariffId,
        itemType: 'tariff',
        quantity: 1,
        details: {
          subscriberType: 'mnp',
          presets: presets,
          additionalServices: additionalServices
        },
        children: [{
          itemType: 'ctn',
          details: {
            ctn: mnp,
            subscriberType: 'mnp'
          },
          quantity: 1
        }]
      };
    }
  }

  /* добавляется только тариф + ctn */
  if (tariffId && ctn) {
    itemsBody = _objectSpread(_objectSpread({}, itemsBody), {}, {
      children: [{
        itemType: 'ctn',
        id: 0,
        details: {
          ctn: ctn,
          ctnType: 'F',
          subscriberType: 'new'
        }
      }]
    });
  }

  /* добавление апикея */
  if (simOrderPlace && API_KEY_PLACES[simOrderPlace] || basketSource) {
    itemsBody = _objectSpread(_objectSpread({}, itemsBody), {}, {
      source: API_KEY_PLACES[simOrderPlace] || basketSource
    });
  }
  body = _objectSpread(_objectSpread({}, body), {}, {
    items: [itemsBody]
  });
  var apiEndpoint = 'Basket';

  /* добавление товаров в новую корзину */
  if (devices) {
    itemsBody = devices.map(function (content) {
      return _objectSpread(_objectSpread({}, content), {}, {
        source: API_KEY_PLACES[simOrderPlace] || basketSource
      });
    });
    body = _objectSpread(_objectSpread({}, body), {}, {
      items: itemsBody
    });
  }
  if (cartId) {
    apiEndpoint = "".concat(apiEndpoint, "/").concat(cartId);
    body = body.items;
  }

  /* добавление товаров в существующую корзину */
  if (devices && cartId) {
    apiEndpoint = "".concat(apiEndpoint, "/merge");
  }
  return {
    body: body,
    apiEndpoint: apiEndpoint
  };
};

/**
 * @desc: форматрирует доп опции для заказа тарифа
 * @param options
 * @returns {object | null}
 */
var formatAdditionalOptions = function formatAdditionalOptions(options) {
  var res = null;
  if (options !== null && options !== void 0 && options.chosenSocs) {
    res = {
      additionalServices: options.chosenSocs.split(',')
    };
  }
  return res;
};
var handleSetCartRedirect = function handleSetCartRedirect(isBasketRedirectEnabled) {
  setCookie({
    name: CART_REDIRECT_COOKIE_NAME,
    value: isBasketRedirectEnabled,
    path: '/',
    domain: getRootCookieDomain()
  });
};

/**
 * @desc: вычисление нужно ли проводить редирект в корзину
 * @returns boolean
 */
var getCartRedirect = function getCartRedirect() {
  return getCookie(CART_REDIRECT_COOKIE_NAME) === 'true';
};

/**
 * @desc: обработка успешного добавления товара в корзину
 * @param {Object} config
 * @param {string=} config.cartId - id корзины, создает/обновляет куку корзины с временем жизни 1 сутки
 * @param {bool=} config.redirectToCart - редирект в корзину
 * @param {Array=} config.items - товары в корзине
 */
var handleSuccessRequest = function handleSuccessRequest(_ref2) {
  var cartId = _ref2.cartId,
    redirectToCart = _ref2.redirectToCart,
    items = _ref2.items,
    basketIdExpiration = _ref2.basketIdExpiration;
  /* обновляем куку */
  if (cartId) {
    setCookie({
      name: CART_ID_COOKIE_NAME,
      value: cartId,
      ttl: basketIdExpiration || CART_COOKIE_TTL,
      path: '/',
      domain: getRootCookieDomain()
    });
    if (items) {
      slAddToCart(items);
    }
  }

  /* редирект в корзину */
  if (redirectToCart) {
    window.location.href = CART_URL;
  }
};
export { BOUGHT_NUMBERS_STORAGE_KEY, CART_URL, formatAdditionalOptions, formatOrderData, getCartId, getCartRedirect, getPurchasedItems, getRegion, handleSetCartRedirect, handleSuccessRequest };